
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/v2/tiempo-real",
      function () {
        return require("private-next-pages/v2/tiempo-real.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/v2/tiempo-real"])
      });
    }
  